import React from 'react';
import MobileInvitations from 'src/components/AccountSettings/mobile-invitations';
import TabBar from 'src/components/AccountSettings/TabBar';
import TabButton from 'src/components/AccountSettings/TabButton';
import {Loading} from './loading';
import {UserType} from 'src/types/enums';
import useAsyncState from '../../../hooks/use-async-state';
import {accountSettingsTabs} from '../utils/utils';

interface Props {
  portal: UserType;
  awardAmount?: number;
}

const MorePage = ({awardAmount, portal}: Props) => {
  const [tabs] = useAsyncState(() => accountSettingsTabs(portal), [], [portal]);

  return (
    <>
      {awardAmount && <MobileInvitations awardAmount={awardAmount} />}
      <TabBar>
        {!tabs.length && <Loading />}
        {tabs.map((tab) => (
          <TabButton key={tab.path} label={tab.label} path={tab.path} icon={tab.mobileIcon} />
        ))}
      </TabBar>
    </>
  );
};

export default MorePage;
